import { Dialog, DialogContent, DialogTrigger } from "components/Dialog";
import { Button, ButtonColor, ButtonFill, ButtonSize } from "components/Button";
import { PlusIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import { VisualizationsService } from "client/openapi";
import Notifications from "util/notifications";

interface CreateVisualizationDialogProps {
  orgId: number;
  onVisualizationCreated: (visualization: any) => void;
}

export default function CreateVisualizationDialog({
  orgId,
  onVisualizationCreated,
}: CreateVisualizationDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");

  const handleSubmit = async () => {
    try {
      const newVisualization = await VisualizationsService.createVisualization({
        requestBody: { name, org_id: orgId },
      });
      onVisualizationCreated(newVisualization);
      setIsOpen(false);
      setName("");
      Notifications.success("Visualization created successfully");
    } catch (error) {
      console.error("Error creating visualization:", error);
      Notifications.error("Failed to create visualization");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>
        <Button
          color={ButtonColor.PURPLE}
          fill={ButtonFill.HOLLOW}
          size={ButtonSize.SMALL}
        >
          Create New <PlusIcon className="ml-1" />
        </Button>
      </DialogTrigger>
      <DialogContent className="visualization-dialog-content">
        <div className="p-4">
          <h2 className="text-lg font-bold text-center mb-4">
            Create New Visualization
          </h2>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 border rounded-md"
              placeholder="Enter visualization name"
            />
          </div>
          <div className="flex justify-center gap-2">
            <Button color={ButtonColor.GRAY} onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button
              color={!name.trim() ? ButtonColor.GRAY : ButtonColor.PURPLE}
              onClick={handleSubmit}
              disabled={!name.trim()}
            >
              Create
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
